/*
=========================================================
* Vuetify Soft UI Dashboard PRO - v1.0.0
=========================================================

* Product Page:  https://store.vuetifyjs.com/products/vuetify-soft-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import DashboardPlugin from "./plugins/dashboard-plugin";
import store from "./store";
import axios from "axios";
import Vuelidate from "vuelidate";
import websocketService from "./utils/websocketService";

// Configure axios (native) globally
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "";
axios.defaults.timeout = 30000;
axios.defaults.headers["Content-Type"] = "application/json";

// Inject auth token on each request
axios.interceptors.request.use((config) => {
  const token = store.getters["user/userToken"];
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 Invalid token responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data &&
      error.response.data.error === "Invalid token"
    ) {
      console.log("Unauthorized access detected. Redirecting to login page...");
      // Redirect to login page
      router.push("/pages/authentication/login");
    }
    return Promise.reject(error);
  }
);

// Make axios available globally
Vue.prototype.$axios = axios;

// Make WebSocket service available globally
Vue.prototype.$websocket = websocketService;

Vue.config.productionTip = false;

// Enable Vue DevTools in development
Vue.config.devtools = process.env.NODE_ENV === "development";

// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(Vuelidate);

// Create Vue instance
const app = new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
});

// Initialize WebSocket connection after authentication
// router.beforeEach((to, from, next) => {
//   // Check if route requires authentication
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false);
//   const isAuthenticated = store.getters['user/isAuthenticated'];
//   console.log('record',to.matched)
//   console.log('before each ',requiresAuth,isAuthenticated,websocketService.isWebSocketConnected())

//   if (requiresAuth && isAuthenticated && !websocketService.isWebSocketConnected()) {
//     // Try to connect WebSocket if authenticated and not already connected
//     websocketService.connect().catch(error => {
//       console.error('Failed to establish WebSocket connection:', error);
//     });
//   } else if (!isAuthenticated && websocketService.isWebSocketConnected()) {
//     // Disconnect WebSocket if user is not authenticated
//     websocketService.disconnect();
//   }

//   next();
// });

// Mount the app
app.$mount("#app");
